// Copyright (c) 2020 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as TagsSlice from "../slice"
import { SearchTagsResponse, SearchTagsRequestSchema } from "generated/legebill/site/tag/v4/tag_pb"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"
import { executor, Init, tagService } from "../../../app/rpc"
import { create } from "@bufbuild/protobuf"

type SearchTagsRpc = (request: Init<typeof SearchTagsRequestSchema>) => Observable<SearchTagsResponse>

export const searchTags = (searchTagsRpc: SearchTagsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.searchTags.match),
      mergeMap(({ payload }) => of(payload)
        .pipe(
          mergeMap(searchTagsRpc),
          map(t => t),
          map(response => TagsSlice.setResultTags({ searchString: payload.searchText ?? "", response })),
          catchError(_ => concat(
            of(TagsSlice.resetResultTags()),
            of(showSnackBar({
              message: t({
                id: "msg_search_tags_failed",
                message: "Failed to search for tags. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com."
              }),
              messageType: "ERROR",
            }))
          )),
        )
      ),
    )

const searchTagsRpc = (request: Init<typeof SearchTagsRequestSchema>): Observable<SearchTagsResponse> =>
  executor(() => tagService.searchTags(create(SearchTagsRequestSchema, request)))

export default searchTags(searchTagsRpc)
